// Gráfico de donut
import graficoDonut from './modulo/donut';
window.graficoDonut = graficoDonut;

//Menu fixo utilizado na lateral dos conteúdos
import menuLateral from "./modulo/menu-fixo-lateral";
window.menuLateralFixo = menuLateral;

//Menu topo fixo após scroll
import menuTopo from "./modulo/menu-topo";
window.menuTopo = menuTopo;

//Selecionar todos os checkbox
import selecionarTodosCheckbox from "./modulo/selecionar-todos-checkbox";
window.selecionarTodosCheckbox = selecionarTodosCheckbox;

//Trabalha hash para redirecionar a tab sem correr a página
import tabHash from "./modulo/tab-hash";
window.tabHash = tabHash;

//Tabelas modile
import tableCardMobile from "./modulo/table-card-mobile";
window.tableCardMobile = tableCardMobile;

//Inicializa os sliders com a classe bussola-slider
import sliders from "./modulo/carrossel";
window.sliders = sliders;

//Inicializa animate módulo
import animateBussola from "./modulo/animate";
window.animateBussola = animateBussola;

//Inicializa maxlength módulo
import maxlength from "./modulo/maxlength";
window.maxlength = maxlength;

//Inicializa o dataTable módulo
import dataTable from "./modulo/dataTable";
window.dataTable = dataTable;

//Inicializa o módulo text-collapse
import textCollapse from "./modulo/text-collapse";
window.textCollapse = textCollapse;

//Inicializa o módulo imagesList
import imagesList from "./modulo/imagesList";
window.imagesList = imagesList;

//Inicializa o módulo dropdownTable
import dropdownTable from "./modulo/dropdownTable";
window.dropdownTable = dropdownTable;

//Inicializacao tabs ajax
import tabsAjax from "./modulo/tabsAjax";
window.tabsAjax = tabsAjax;

// Menu Principal Esquerdo
import menuPrincipalEsquerdo from "./modulo/menuPrincipal";
window.menuPrincipalEsquerdo = menuPrincipalEsquerdo;

// Zend desk ícone
import zendeskCustom from "./modulo/zendesk-chat";
window.zendeskCustom = zendeskCustom;

//bussolaPopUp
import arrowBorder from "./modulo/arrow-border";
window.arrowBorder = arrowBorder;

//textareaResize
import textareaResize from "./modulo/textareaResize";
window.textareaResize = textareaResize;

// Gráfico - Semi círculo
import semiCirculo from "./modulo/semi-circulo";
window.semiCirculo = semiCirculo;

//Gráfico - Adiciona legendas customizadas clicáveis no AMCHARTS
import customLegendCharts from "./modulo/custom-legend-amcharts";
window.customLegendCharts = customLegendCharts;

//Abstrai a utilização do leaflet como mapa.
import mapa from "./modulo/mapa";
window.mapa = mapa;

//Daterangerpicker
import dateranger from './modulo/daterangerpicker';
window.dateranger  = dateranger;

//Daterangerpicker
import ajuda from './modulo/ajuda';
window.ajuda  = ajuda;

//Confirmação
import BussolaUiConfirmacao from './modulo/confirmacao';
window.BussolaUiConfirmacao = BussolaUiConfirmacao;


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulos.js